@if (HasRequiredPermissions) {
@if (hasWebSocketChanges()) {
<div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
  <span class="text-xs text-yellow-800">
    {{ 'Record ' | translate }} {{ 'modified' | translate }}.
    ({{ totalModifiedCount() }} {{ 'changes' | translate }})
  </span>
</div>
}
@if (EntityInstance || isNew()) {
<!-- Conteneur principal avec layout flexbox -->
<div [fieldContext]="this" class="flex flex-col h-full">
  <!-- Titre fixe en dehors de la zone de défilement -->
  <div class="px-6 pt-4 pb-2">
    <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
      @if (isNew()) {
      {{ 'entities.account.newEntity' | translate }}
      } @else {
      {{ 'entities.account.detailEntity' | translate }}
      }
    </h4>
    <div class="flex justify-between items-center">
      <button (click)="cancelEdit()" data-testid="detail-close"
        class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  <!-- Dock Infos Section -->
  <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
    <div class="">
      <h3 class="{{Skin.formSectionSmallTitle}}">
        <i class="fa-solid fa-user"></i> {{
        'vues.account.detail.sections.account-info' | translate
        }}
      </h3>
      <div class="space-y-2">
        <!-- Champ selectedPK_Pos (multi-select) -->
        <app-field-wrapper property="selectedPK_Pos" businessProperty="accountPOS" label="entities.account.propreties.pos">
          <app-multi-select #multiSelect
            [options]="posResponsible"
            [placeholder]="'Select Sites'"
            [isReactive]="true"
            [skin]="Skin"
            reactiveIconAdditionalDataName="truckerresponsibleicon"
            [selectedKeys]="editingEntity()?.selectedPK_Pos || []"
            (selectedKeysChange)="onPOSselectChange($event)"
            (statusChange)="onPosResponsibleChanged($event)"
            onReady
            (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect)">
          </app-multi-select>
        </app-field-wrapper>
        <!-- Champ name -->
        <app-field-wrapper property="name">
          <input type="text" autocomplete="off" onReady

            class="{{Skin.formInputSmallSize}}"
            (autoBind)="bindingHandler($event, 'name')">
        </app-field-wrapper>
        <!-- Champ email (imutable après création : identifiant du compte Identity) -->
        <app-field-wrapper property="email">
          <input type="email" autocomplete="off" onReady [readonly]="!isNew()"

            class="{{Skin.formInputSmallSize}}"
            (autoBind)="bindingHandler($event, 'email')">
        </app-field-wrapper>
        <!-- Champ phoneNumber -->
        <app-field-wrapper property="phoneNumber">
          <input type="tel" autocomplete="off" onReady

            class="{{Skin.formInputSmallSize}}"
            (autoBind)="bindingHandler($event, 'phoneNumber')">
        </app-field-wrapper>
        <!-- Champ password -->
        <app-field-wrapper property="password">
          <input type="password" autocomplete="off" onReady

            class="{{Skin.formInputSmallSize}}"
            (autoBind)="bindingHandler($event, 'password')">
        </app-field-wrapper>
        <!-- Champ confirmPassword -->
        <app-field-wrapper property="confirmPassword">
          <input type="password" autocomplete="off" onReady

            class="{{Skin.formInputSmallSize}}"
            (autoBind)="bindingHandler($event, 'confirmPassword')">
        </app-field-wrapper>
        <!-- Champ fK_i18nLanguage (select) -->
        <app-field-wrapper property="fK_i18nLanguage" label="entities.account.propreties.language">
          <select class="{{Skin.formInputSmallSize}}" required onReady

            (autoBind)="bindingHandler($event, 'fK_i18nLanguage')">
            <option [value]="null" disabled>{{ 'Choose a language' | translate }}</option>
            @for (languageOption of getLookupData('i18nLanguage'); track languageOption.key) {
            <option [value]="languageOption.key">{{ `languages.${languageOption.value}` | translate }}</option>
            }
          </select>
        </app-field-wrapper>
      </div>
    </div>
    <div class="mt-10">
      <h3 class="{{Skin.formSectionSmallTitle}}">
        <i class="fas fa-lock"></i> {{
        'vues.account.detail.sections.security' | translate
        }}
      </h3>
      <div class="space-y-2">
        <!-- Champ fK_Role (select) -->
        <app-field-wrapper property="fK_Role" label="entities.account.propreties.role">
          <select class="{{Skin.formInputSmallSize}}" required onReady

            (autoBind)="bindingHandler($event, 'fK_Role')"
            (change)="onRoleChange($event)">
            <option [value]="null" disabled>{{ 'Choose a role' | translate }}</option>
            @for (roleOption of roleLookup(); track roleOption.key) {
            <option [value]="roleOption.key">{{ roleOption.value }}</option>
            }
          </select>
        </app-field-wrapper>
        <!-- Champ twoFactorEnabled (checkbox) -->
        <app-field-wrapper property="twoFactorEnabled">
          <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

            (autoBind)="bindingHandler($event, 'twoFactorEnabled')">
        </app-field-wrapper>
        <!-- Champ isDisabled (checkbox) : bloque la connexion côté Auth.Server -->
        <app-field-wrapper property="isDisabled">
          <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

            (autoBind)="bindingHandler($event, 'isDisabled')">
        </app-field-wrapper>
      </div>
    </div>
    <div class="mt-10">
      <h3 class="{{Skin.formSectionSmallTitle}}">
        <i class="fas fa-envelope"></i> {{
        'vues.account.detail.sections.notifications' | translate
        }}
      </h3>
      <div class="space-y-2">
        <!-- Champ healthNotification (checkbox) -->
        <app-field-wrapper property="healthNotification">
          <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

            (autoBind)="bindingHandler($event, 'healthNotification')">
        </app-field-wrapper>
        <!-- Champ dailyReport (checkbox) -->
        <app-field-wrapper property="dailyReport">
          <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

            (autoBind)="bindingHandler($event, 'dailyReport')">
        </app-field-wrapper>
        <!-- Champ weeklyReport (checkbox) -->
        <app-field-wrapper property="weeklyReport">
          <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

            (autoBind)="bindingHandler($event, 'weeklyReport')">
        </app-field-wrapper>
        <!-- Champ monthlyReport (checkbox) -->
        <app-field-wrapper property="monthlyReport">
          <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

            (autoBind)="bindingHandler($event, 'monthlyReport')">
        </app-field-wrapper>
      </div>
    </div>
  </div>
  <!-- Bandeau pour le nombre d'erreurs -->
  @if (generalErrorCount() > 0) {
  <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
    <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
    {{ generalErrorCount() }} erreur(s) dans le formulaire
  </div>
  }
  <!-- Boutons en bas du formulaire -->
  <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
    @if (HasEditPermission) {
    <button name="SaveButton" data-testid="detail-save"
      type="button" (click)="saveItem()" [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save' | translate }}
    </button>
    }
    @if (HasEditPermission) {
    <button name="SaveAndCloseButton" data-testid="detail-save-close"
      type="button" (click)="saveAndCloseItem()" [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save-and-close' | translate }}
    </button>
    }
    <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
      <i class="fas fa-times mr-2"></i>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</div>
}
}